const brandKeys = {
  getBrandDetail: (payload: any) => ['getBrandDetail', payload],
  getBenefits: (payload: BrandBenefitParams) => ['getBenefits', payload],
};

export default brandKeys;
